import Formula from "../singleton/formula";
import Extras from "../singleton/extras";
import CollectionTotals from "../singleton/collection-totals";
import CollectionSorting from "../singleton/collection-sorting";
import CollectionFilters from "../singleton/collection-filters";

export default {

    View: {

        setFilters: Extras.viewSetFilters.bind(Extras),

        toggleFieldSort: Extras.viewToggleFieldSort.bind(Extras),

        setFieldsOrder: Extras.viewSetFieldsOrder.bind(Extras),

        setFieldWidth: Extras.viewSetFieldWidth.bind(Extras),

        toggleFieldHidden: Extras.viewToggleFieldHidden.bind(Extras),

        toggleLocked: Extras.viewToggleLocked.bind(Extras)

    },

    Sort: {

        run: CollectionSorting.sort.bind(CollectionSorting),

        prepare: CollectionSorting.prepare.bind(CollectionSorting),

        getValue: CollectionSorting.getValue.bind(CollectionSorting)

    },

    Filter: {

        run: CollectionFilters.filter.bind(CollectionFilters),

        prepare: CollectionFilters.prepare.bind(CollectionFilters)

    },

    totals: CollectionTotals.get.bind(CollectionTotals),

    formula: Formula.processDocument.bind(Formula)

}